import React, { useState, useEffect } from "react";
import styled from "styled-components";
import ListHeader from "./list-header";
import ListBody from "./ListBody";

const List = ({ items, selectPerspective, newPerspective, deleteObject  }, props) => {
  const [filteredList, setFilteredList] = useState([]);

  useEffect(() => {
    setFilteredList(items);
  }, [items]);

  const onFilterList = (filterName) => {
    if (filterName.length > 0) {
      const filteredList = items.filter((item) => {
        return item.name.toLowerCase().includes(filterName.toLowerCase());
      });
      setFilteredList(filteredList);
    } else {
      setFilteredList(items);
    }
  };

  return (
    <ListContainer>
      <ListHeader
        newPerspective={newPerspective}
        filterFunction={onFilterList}
      />
      <ListBody 
      items={filteredList} 
      selectPerspective={selectPerspective} 
      deleteObject={deleteObject}/>
    </ListContainer>
  );
};

const ListContainer = styled.div`
  width: 100%;
`;

export default List;
